import breakTo from '../../styles/tools/breakTo'
import genericsFn from '../../styles/generics/styles'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes
}) => {
  const generics = genericsFn({
    colors,
    spacings,
    fontFamilies,
    fontWeights,
    fontSizes
  })

  const styles = {
    container: {
      [breakTo('smaller')]: {
        display: 'block'
      }
    },

    'thank-you': {
      width: '100%',
      marginRight: 'auto',
      marginLeft: 'auto'
    },

    'thank-you__img': {
      maxWidth: '30rem',
      height: '20rem',
      marginRight: 'auto',
      marginLeft: 'auto',

      backgroundImage: images.welcome,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: spacings.thankYouImg.backgroundPosition.default,
      backgroundSize: 'contain',

      [breakTo('smaller')]: {
        height: '28rem',
        backgroundPosition: spacings.thankYouImg.backgroundPosition.smaller
      }
    },

    'thank-you__text': {
      textAlign: 'center'
    },

    'thank-you__parent': {
      marginTop: '2rem'
    },

    'thank-you__parent--hidden': {
      display: 'none'
    }
  }

  return { ...generics, ...styles }
}



// WEBPACK FOOTER //
// ./containers/endOfTheRide/styles.js